import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const TypesOfOptions = () => {
  return (
    <div className="bg-[#0b0d2a] text-white">
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="relative bg-cover bg-center h-64 flex items-center justify-center"
        style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
        <h1 className="text-4xl font-bold text-white drop-shadow-md">Types of options</h1>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10 space-y-6">
        <h2 className="text-2xl font-semibold mb-4">TYPES OF OPTIONS – CALLS AND PUTS</h2>

        <div className="space-y-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Call Option Definition:</h3>
            <p className="mb-4">
              A call option is an option contract in which the holder (buyer) has the right <em>(but not the obligation)</em> to buy a specified quantity of a security at a specified price (strike price) within a fixed period of time (until its expiration).
            </p>
            <p className="mb-4">
              For the writer (seller) of a call option, it represents an obligation to sell the underlying security at the strike price if the option is exercised. The call option writer is paid a premium for taking on the risk associated with the obligation.
            </p>
            <p className="mb-4">
              For stock options, each contract covers 100 shares.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Buying Call Options</h3>
            <p className="mb-4">
              Call buying is the simplest way of trading call options. Novice traders often start off trading options by buying calls, not only because of its simplicity but also due to the large ROI generated from successful trades.
            </p>

            <div className="bg-gray-800 p-6 rounded-lg">
              <h4 className="font-semibold mb-3">A Simplified Example</h4>
              <p className="mb-4">
                Suppose the stock of XYZ company is trading at $40. A call option contract with a strike price of $40 expiring in a month's time is being priced at $2. You strongly believe that XYZ stock will rise sharply in the coming weeks after their earnings report. So, you paid $200 to purchase a single $40 XYZ call option covering 100 shares.
              </p>
              <p>
                Say you were spot on and the price of XYZ stock rallies to $50 after the company reported strong earnings and raised its earnings guidance for the next quarter. With this sharp rise in the underlying stock price, your call buying strategy will net you a profit of $800.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Put Option Definition:</h3>
            <p className="mb-4">
              A put option is an option contract in which the holder (buyer) has the right <em>(but not the obligation)</em> to sell a specified quantity of a security at a specified price (strike price) within a fixed period of time (until its expiration).
            </p>
            <p className="mb-4">
              For the writer (seller) of a put option, it represents an obligation to buy the underlying security at the strike price if the option is exercised. The put option writer is paid a premium for taking on the risk associated with the obligation.
            </p>
            <p className="mb-4">
              For stock options, each contract covers 100 shares.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Buying Put Options</h3>
            <p className="mb-4">
              Put buying is the simplest way to trade put options. When the options trader is bearish on particular security, he can purchase put options to profit from a slide in asset price. The price of the asset must move significantly below the strike price of the put options before the option expiration date for this strategy to be profitable.
            </p>

            <div className="bg-gray-800 p-6 rounded-lg">
              <h4 className="font-semibold mb-3">A Simplified Example</h4>
              <p className="mb-4">
                Suppose the stock of XYZ company is trading at $40. A put option contract with a strike price of $40 expiring in a month's time is being priced at $2. You strongly believe that XYZ stock will drop sharply in the coming weeks after their earnings report. So, you paid $200 to purchase a single $40 XYZ put option covering 100 shares.
              </p>
              <p>
                Say you were spot on and the price of XYZ stock plunges to $30 after the company reported weak earnings and lowered its earnings guidance for the next quarter. With this crash in the underlying stock price, your put buying strategy will result in a profit of $800.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypesOfOptions; 